import React from 'react';
import Modal from '@/ctComponents/Modal';
import { TableV2 } from '@/components/TableV2';

const TABLE_HEADERS = [
  '#',
  'Name',
  'Last Name',
  'Company',
  'Referral Date',
  'Email',
  'Phone Number',
  'Status',
];

export const ReferralHistory = ({ data, show, setShow }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'accepted':
        return 'bg-success-light text-success';
      case 'expired':
        return 'bg-error-light text-error';
      case 'pending':
      default:
        return 'bg-gray-100 text-inactive-text';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options).replace(',', ', ');
    } catch {
      return '-';
    }
  };

  const prepareTableData = () => {
    return data.map((item, index) => ({
      id: item.id,
      cellData: [
        index + 1,
        item.f_name || '-',
        item.l_name || '-',
        item.company || '-',
        formatDate(item.created_at),
        item.email || '-',
        item.phone || '-',
        <span
          className={`font-medium h-5 flex items-center justify-center px-3 rounded-full ${getStatusColor(
            item.status_text
          )}`}>
          {item.status_text || 'Pending'}
        </span>,
      ],
    }));
  };

  return (
    <Modal
      minWidth="unset"
      show={show}
      notClose={true}
      children={
        <div className="overflow-x-auto max-w-sm sm:max-w-none">
          <p className="text-sm text-secondary-text my-6">
            View your referral history, including who you invited, when, and
            their current status.
          </p>

          <div className="w-full">
            <TableV2
              minWidth={760}
              headers={TABLE_HEADERS}
              data={prepareTableData()}
              emptyMessage="No referral history available"
            />
          </div>
        </div>
      }
      icon={'timeFile'}
      title="Referral History"
      setShow={setShow}
    />
  );
};
